import $ from 'jquery';

class CountryEditor {
	
	constructor() {

		let countryID = $("#countryID").data("id");

		$("#doSaveAddress").click(function(e) {
	        e.preventDefault();
	        $.ajax({
	            data:{op:"setCountryAddress",id:countryID,address:$("#address").val()},
	            success: (d, s) => {
	                $("#country_address").html($("#address").val().split("\n").join("<br />"));
	                $("#editCountryAddress").modal("hide");
	            }
	        });
	    });

			$(".doSaveCLogo").each(function(i, el) {
				$(el).click(function(e) {
					e.preventDefault();
					
					const logo = $(el).data("logo");

					let image = $("#uploader_logo_" + logo).val();

					$.ajax({
						data:{op:"setCountryLogo",id:countryID,logo:image,type:logo},
						success: (d, s) => {
							$("#country_logo_" + logo).attr("src", d.url);
							$("#editCountryLogo" + logo).modal("hide");
						}
					});
				});
				
			});
	    

	    $("#doSaveURL").click(function(e) {
	        e.preventDefault();
	        $.ajax({
	            data:{op:"setCountryURL",id:countryID,url:$("#country_url").val()},
	            success: (d, s) => {
								let url = $("#country_url").val();
								if (url.substring(0, "http".length) !== "http") {
									url = "//" + url;
								}
	            	var a = $("<a></a>").attr("href", url).html($("#country_url").val()).attr("target", "_blank");
	                $("#country_website").html(a);
	                $("#editCountryURL").modal("hide");
	            }
	        });
	    });

	    $("#doSaveCName").click(function(e) {
	        e.preventDefault();
	        $.ajax({
	            data:{op:"setCountryCompany",id:countryID,name:$("#country_company").val()},
	            success: (d, s) => {
	            	$("#company_name").html($("#country_company").val());
	                $("#editCountryCompany").modal("hide");
	            }
	        });
	    });


	    $("#doaddyear").click(function() {

        $.ajax({
            data:{op:"addEdition",country:countryID,year:$("#edition_year").val()}
        });

    });

	}


}

export default CountryEditor;

